import type { HTMLAttributes, ReactNode } from 'react'
import React from 'react'
import { csx, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'

import type { mapOffersToProductPrice } from '../../../../core/utils/productSkuOfferConnection'
import { Price } from '../../../../core/components'

export type OfferDeliveryMethodInfoProps = {
  icon: ReactNode
  title: string
  shouldRenderPrice: boolean
  offers: ReturnType<typeof mapOffersToProductPrice>
} & HTMLAttributes<HTMLDivElement>

export const OfferDeliveryMethodInfo = ({
  icon,
  title,
  shouldRenderPrice,
  offers,
  ...props
}: OfferDeliveryMethodInfoProps) => {
  const offersCount = offers.length

  const allOffersHasSamePrice = offers.every(
    (offer) => offer.netPrice.amount === offers[0]?.netPrice.amount
  )

  const renderTitle = () => {
    if (offersCount > 1) {
      return `${title} (${offersCount})`
    }

    return title
  }

  const shouldRenderStartingFromLabel =
    !allOffersHasSamePrice && shouldRenderPrice

  return (
    <div
      className={csx({
        display: 'flex',
        alignItems: 'center',
        ':not(:last-child)': {
          borderRight: '$neutral',
          paddingRight: '$space-6',
          marginRight: '$space-6',
        },
      })}
      {...props}
    >
      {icon}
      <div className={csx({ marginLeft: '$space-3' })}>
        <Text variant="action2" className={csx({ display: 'block' })}>
          {renderTitle()}
        </Text>
        {shouldRenderStartingFromLabel && (
          <Text
            variant="detail"
            tone="secondary"
            className={csx({ display: 'block', marginTop: '$space-05' })}
          >
            <FormattedMessage id="price-starting-from" />
          </Text>
        )}
        {shouldRenderPrice && (
          <Text
            variant="action2"
            tone="secondary"
            className={csx({ display: 'block', marginTop: '$space-05' })}
          >
            <Price value={offers[0]?.netPrice.amount / 100} />
          </Text>
        )}
      </div>
    </div>
  )
}
